"use client";
import { jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { Analytics } from "../../../../../Analytics/index.js";
import { KEY_CART_ADD, TRACK_TYPE_MULTI_ATTR, CATEGORY_PAGE_TYPE, ONE, KEY_SEARCH_CLICK } from "../../../../../Analytics/constants.js";
import { useCartContext } from "../../../../../Chrome/CartContext/hook.js";
import { productActionsVariant } from "../../../constants.js";
import { useAuth } from "../../../../../../hooks/auth/useAuth/index.js";
import { useProductTileData } from "../../../../../../hooks/useProductTileData/index.js";
import { AddToCartButton } from "./AddToCartButton.js";
import { OutOfStockIndicator } from "./OutOfStockIndicator.js";
import { ProductDetailsButton } from "./ProductDetailsButton.js";
import { SignInButton } from "./SignInButton.js";
import { buttonStyles } from "./styles.js";
const ProductActionsComponent = ({
  refreshCartCallback,
  pdpNavigationUrl,
  pageType
}) => {
  var _a;
  const { normalizedData, translationsConfig, productTitleId } = useProductTileData();
  const { signIn } = useAuth();
  const { productActions, productInfoData } = normalizedData;
  if (!productActions) {
    return null;
  }
  const {
    maxQuantity,
    minQuantity,
    type: productActionType,
    contractIdentifier,
    partNumber,
    itemNumber
  } = productActions || {};
  const { translations, urls } = translationsConfig;
  const {
    signinbuttonlabel,
    selectoptionsbuttonlabel,
    removeitemerror,
    seedetailsbuttonlabel,
    addtocartsuccessmessage,
    genericerror,
    addbuttonlabel,
    removeitemarialabel,
    quantity,
    increasequantity,
    decreasequantity,
    outofstock
  } = translations || {};
  switch (productActionType) {
    case productActionsVariant.OutOfStock:
      return /* @__PURE__ */ jsx(OutOfStockIndicator, { label: outofstock ?? "" });
    case productActionsVariant.SignInButton:
      return /* @__PURE__ */ jsx(
        Analytics,
        {
          analyticData: {
            trackedData: [{ key: KEY_SEARCH_CLICK, value: ONE }]
          },
          children: /* @__PURE__ */ jsx(
            SignInButton,
            {
              buttonStyles,
              onClick: signIn,
              pdpNavigationUrl,
              productInfoData,
              productTitleId,
              signinbuttonlabel
            }
          )
        }
      );
    case productActionsVariant.SelectOptions:
    case productActionsVariant.SeeDetails:
      return /* @__PURE__ */ jsx(
        Analytics,
        {
          analyticData: {
            trackedData: [{ key: KEY_SEARCH_CLICK, value: ONE }]
          },
          children: /* @__PURE__ */ jsx(
            ProductDetailsButton,
            {
              type: productActionType,
              productActionsVariant,
              pdpNavigationUrl,
              productInfoData,
              productTitleId,
              seedetailsbuttonlabel,
              selectoptionsbuttonlabel
            }
          )
        }
      );
    case productActionsVariant.QuantitySelector:
      return /* @__PURE__ */ jsx(
        Analytics,
        {
          analyticData: {
            trackType: TRACK_TYPE_MULTI_ATTR,
            trackedData: [
              {
                key: KEY_CART_ADD,
                value: pageType === CATEGORY_PAGE_TYPE ? 1 : ((_a = window == null ? void 0 : window.digitalData) == null ? void 0 : _a.pageName) ? window.digitalData.pageName : ""
              }
            ]
          },
          children: /* @__PURE__ */ jsx(
            AddToCartButton,
            {
              maxQuantity,
              contractIdentifier,
              itemNumber,
              minQuantity,
              partNumber,
              urls,
              addbuttonlabel,
              decreasequantity,
              addtocartsuccessmessage,
              increasequantity,
              quantity,
              removeitemarialabel,
              removeitemerror,
              genericerror,
              productTitleId,
              refreshCartCallback
            }
          )
        }
      );
  }
};
const MemoizedProductActionsComponent = memo(ProductActionsComponent);
const ProductActions = ({
  pdpNavigationUrl,
  pageType
}) => {
  const { refreshCart } = useCartContext();
  const refreshCartCallback = useCallback(() => {
    refreshCart();
  }, []);
  return /* @__PURE__ */ jsx(
    MemoizedProductActionsComponent,
    {
      pageType,
      pdpNavigationUrl,
      refreshCartCallback
    }
  );
};
export {
  ProductActions
};
